import React from 'react';

const FloatingBubbles = ({ count = 15 }) => {
  // Generate random properties for each bubble
  const bubbles = Array.from({ length: count }, (_, i) => ({
    id: i,
    size: Math.random() * 40 + 20, // 20-60px
    left: Math.random() * 100, // 0-100%
    color: Math.random() > 0.5 ? '#FF8C00' : '#10B981', // Orange or Green
    delay: Math.random() * 5, // 0-5s delay
    duration: Math.random() * 10 + 15, // 15-25s duration
    opacity: Math.random() * 0.15 + 0.05 // 0.05-0.2 opacity
  }));

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {bubbles.map((bubble) => (
        <div
          key={bubble.id}
          className="absolute rounded-full blur-xl animate-float"
          style={{
            width: `${bubble.size}px`,
            height: `${bubble.size}px`,
            left: `${bubble.left}%`,
            bottom: '-50px',
            backgroundColor: bubble.color,
            opacity: bubble.opacity,
            animationDelay: `${bubble.delay}s`,
            animationDuration: `${bubble.duration}s`
          }}
        />
      ))}
    </div>
  );
};

export default FloatingBubbles;
